import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/error.svg'


const _withScopeId = n => (_pushScopeId("data-v-273a5e72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12 col-md-8 col-lg-6 col-xl-5 col-xxl-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  id: "errorImage"
}, null, -1))
const _hoisted_5 = { id: "errorText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t('not-found')), 1),
          (_ctx.showsRetryButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retry && _ctx.retry(...args))),
                class: "btn btn-secondary",
                id: "retryButton"
              }, _toDisplayString(_ctx.t('retry')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}